import { FC, useMemo, useEffect } from 'react';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { AppLoader } from 'components/Core/AppLoader';
import { BrandRequestForm } from 'components/Forms/BrandRequestForm/BrandRequestForm';
import { PointRequestForm } from 'components/Forms/PointRequestForm/PointRequestForm';
import { ProductRequestForm } from 'components/Forms/ProductRequestForm/ProductRequestForm';
import { CatalogueRequestForm } from 'components/Forms/CatalogueRequestForm/CatalogueRequestForm';
import { EntityType } from 'types/common';
import styles from './request.module.scss';

const Request: FC = observer(() => {
  const {
    requestsStore: { getRequestsEntityData },
    mainStore: { user },
  } = useStore();

  const { entity, id } = useParams();
  const navigate = useNavigate();

  const { isLoading, mutate } = useMutation(getRequestsEntityData, {
    mutationKey: 'getRequestsEntityData',
    onError: () => navigate('requests'),
  });

  useEffect(() => {
    id && entity && mutate({ id, entity: entity as EntityType });
  }, [user?.selectedCountryCode]);

  const component = useMemo(() => {
    switch (entity) {
      case 'brands':
        return <BrandRequestForm />;
      case 'points':
        return <PointRequestForm />;
      case 'products':
        return <ProductRequestForm />;
      case 'catalogues':
        return <CatalogueRequestForm />;
      default:
        return null;
    }
  }, [entity]);

  return <main className={styles.page}>{isLoading ? <AppLoader /> : component}</main>;
});

export default Request;
